import React from "react";
import * as Styled from "./styles";

interface PageTitleProps {
  children: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ children }) => (
  <Styled.Title>{children}</Styled.Title>
);

export default PageTitle;